var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2C3765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.198 27.0009H21.0005V39H25.198V27.0009Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 21C21.7835 21 20.7555 22.2098 21.051 23.5685C21.2228 24.3591 21.8693 24.9955 22.6624 25.1546C24.0161 25.4274 25.1981 24.402 25.1981 23.0988C25.1981 21.942 24.2611 21 23.0993 21Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.998 30.6857C38.7151 28.4253 37.5837 27.0009 34.5277 27.0009C32.3582 27.0009 31.4944 27.3393 30.9969 28.2864V27.0009H27.5974V39H31.0954V32.7188C31.0954 31.1504 31.3934 29.9659 33.3305 29.9659C35.2677 29.9659 35.394 31.4232 35.394 32.8198V39H38.9955C38.9955 39 39.0611 31.2161 38.9955 30.6882L38.998 30.6857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.274e7dff5d3d395798df574d0cc45d20.svg";
export { ForwardRef as ReactComponent };